export const CalendarItemKind = {
  appointment: 'appointment',
  followUp: 'follow_up',
  followUpDay: 'follow_up_day',
  taskDeadline: 'task_deadline',
  taskGroup: 'task_group',
}

export const CalendarSource = {
  appointment: 'appointment',
  followUp: 'follow_up',
  taskDeadline: 'task_deadline',
}

export const CalendarScope = {
  building: 'building',
  mine: 'mine',
}

export const CalendarAppointmentStatus = {
  cancelled: 'cancelled',
  confirmed: 'confirmed',
}
